<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software: you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation, either
 * version 3 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with OrangeHRM.
 * If not, see <https://www.gnu.org/licenses/>.
 */
 -->

<template>
  <teleport to="#app">
    <oxd-dialog
      v-if="show"
      class="orangehrm-dialog-modal"
      @update:show="onCancel"
    >
      <div class="orangehrm-modal-header">
        <oxd-text type="card-title">{{ title }}</oxd-text>
      </div>
      <oxd-divider />
      <oxd-form @submit-valid="onConfirm">
        <oxd-form-row>
          <oxd-input-field
            v-model="comment"
            type="textarea"
            :label="
              required
                ? $t('expensa.comment_required')
                : $t('expensa.comment_optional')
            "
            :rules="rules"
            :required="required"
          />
        </oxd-form-row>
        <oxd-divider />
        <oxd-form-actions>
          <oxd-button
            type="button"
            display-type="ghost"
            :label="$t('general.cancel')"
            @click="onCancel"
          />
          <oxd-button
            type="submit"
            display-type="secondary"
            :label="confirmLabel"
          />
        </oxd-form-actions>
      </oxd-form>
    </oxd-dialog>
  </teleport>
</template>

<script>
import {OxdDialog} from '@ohrm/oxd';
import {
  required,
  shouldNotExceedCharLength,
} from '@/core/util/validation/rules';

// Raccoglie un commento: il server accetta fino a 2000 caratteri.
export default {
  name: 'ExpensaCommentDialog',
  components: {
    'oxd-dialog': OxdDialog,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    confirmLabel: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: false,
      comment: '',
      resolve: null,
    };
  },
  computed: {
    rules() {
      return this.required
        ? [required, shouldNotExceedCharLength(2000)]
        : [shouldNotExceedCharLength(2000)];
    },
  },
  methods: {
    /**
     * Apre il dialog. Risolve con il commento (stringa, anche vuota se
     * facoltativo) oppure con null se l'utente annulla.
     */
    showDialog() {
      return new Promise((resolve) => {
        this.comment = '';
        this.resolve = resolve;
        this.show = true;
      });
    },
    onConfirm() {
      this.show = false;
      this.resolve && this.resolve(this.comment.trim());
    },
    onCancel() {
      this.show = false;
      this.resolve && this.resolve(null);
    },
  },
};
</script>
